import { formatIsoDate } from '@payaca/custom-fields';
import { createContext, type ReactNode, useContext } from 'react';

/** Formats a stored ISO-8601 date (`YYYY-MM-DD`) for display. */
export type IsoDateFormatter = (isoDate: string) => string;

/**
 * How date custom fields are formatted for display. Defaults to the runtime
 * locale; an app supplies its own formatter (e.g. the user's preferred date
 * format) via {@link CustomFieldDateFormatProvider} so date custom fields match
 * every other date in that app.
 */
const IsoDateFormatterContext = createContext<IsoDateFormatter>(formatIsoDate);

export const CustomFieldDateFormatProvider = (props: {
  formatter: IsoDateFormatter;
  children: ReactNode;
}) => {
  const { formatter, children } = props;
  return (
    <IsoDateFormatterContext.Provider value={formatter}>
      {children}
    </IsoDateFormatterContext.Provider>
  );
};

export const useIsoDateFormatter = (): IsoDateFormatter =>
  useContext(IsoDateFormatterContext);
